import React from 'react'
import InventorySettings from './InventorySettings'
import Table1 from './Table1'
import Table2 from './Table2'
function Tab2({ formData, onFieldChange, extraData }) {
    return (
        <div className="px-4 py-4" style={{ background: 'white' }}>
            <InventorySettings
                formData={formData}
                onFieldChange={onFieldChange}
                extraData={extraData}
            />
               <Table1
                title="Barcodes"
                setselected_item_data={[]}
                createNewRow={[]}
                columns={extraData.ItemColumnsTab2Table1}
                rows={[]}
                setRows={() => { }}
                list_data={() => { }}
                po_status={""}
            />
            <Table2
                title="Auto re-order"
                setselected_item_data={[]}
                createNewRow={[]}
                columns={extraData.ItemColumnsTab2Table2}
                rows={[]}
                setRows={() => { }}
                list_data={() => { }}
                po_status={""}
            />
        </div>
    )
}

export default Tab2
